import React, {useEffect, useRef, useState} from "react";
import MobileLayout from "./components/layout/MobileLayout";
import DesktopLayout from "./components/layout/DesktopLayout";
import {setBlackURL, setImageStats, setManipulating, setOriginalImage, setOriginalStats, setRed, setStatsLoading, setStatsSet} from "./lib/slices/imageSlice";
import {useDispatch} from "react-redux";
// eslint-disable-next-line import/no-webpack-loader-syntax
import readWorker from 'workerize-loader!./workers/readImage.worker.js';


export default function AppContent() {
    const dispatch = useDispatch();
    const [mobile,] = React.useState(window.innerWidth < 900);
    const localState = useRef({initialized: false}); // To prevent multiple initial renders
    const [worker] = useState(readWorker());

    // Perform a check for specific URL query params
    useEffect(() => {
        (async () => {
            if (localState.current.initialized) return;
            localState.current.initialized = true;
            const params = new URLSearchParams(window.location.search);
            const img = params.get('img');
            const rgb = parseInt(params.get('rgb'), 10);
            if (img) {
                dispatch(setManipulating(true));
                dispatch(setStatsLoading(true));
                const res = await fetch(`https://amoledify.amoled.in/e.php?url=${img}`);
                
                const blob = await res.blob();
                const file = new File([blob], `oledified_${new Date().toISOString()}`, { type: blob.type });
                const localUrl = URL.createObjectURL(file);

                dispatch(setOriginalImage(localUrl));
                dispatch(setManipulating(false));
                worker.addEventListener('message', e => {
                    if (e.data.type === 'stats') {
                        dispatch(setImageStats(e.data.data));
                        dispatch(setOriginalStats(e.data.data));
                        dispatch(setStatsLoading(false));
                        dispatch(setStatsSet(true));
                    }
                    if (e.data.type === 'imageData') {
                        dispatch(setBlackURL(e.data.data));
                    }
                })
                worker.postMessage({
                    type: 'readImageStats',
                    options: {data: true},
                    url: localUrl,
                });
            }
            if (rgb) {
                dispatch(setRed(rgb));
            }
        })()
    }, [window.location.search]);

    return (
        <>
            {mobile ? <MobileLayout/> : <DesktopLayout/>}
        </>
    );
}

